module.exports = __webpack_public_path__ + "1ed73201e360abb11bce105851833f7a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Swift-Icons.eot?-v0i0qt
// module id = 1484
// module chunks = 0